import { useTranslation } from 'react-i18next';

import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';

import { CommitmentAvatarGroup } from '../commitment-avatar-group/commitment-avatar-group.tsx';

export enum MakeAPaymentAlertType {
  payAhead,
  paymentDue,
  missingPayment,
}

export interface MakeAPaymentAlertProps {
  alertType: MakeAPaymentAlertType;
  onButtonClick: () => void;
  commitments?: GraphQLCommitment[];
  amountDue?: number;
  className?: string;
}

export const MakeAPaymentAlert = ({
  alertType,
  commitments,
  amountDue,
  className,
  onButtonClick,
}: MakeAPaymentAlertProps) => {
  const { t } = useTranslation(['my', 'core']);
  const variant =
    alertType === MakeAPaymentAlertType.missingPayment ? 'negative' : 'neutral';
  const translationKey = MakeAPaymentAlertType[alertType];
  return (
    <Alert
      className={className}
      noIcon
      mobileCentered
      title={t(`my:makeAPayment.alerts.${translationKey}.title`)}
      message={t(`my:makeAPayment.alerts.${translationKey}.message`, {
        amountDue: t('numbers.currencyCustom', {
          amount: amountDue,
        }),
      })}
      middleColumn={
        alertType !== MakeAPaymentAlertType.payAhead &&
        commitments &&
        commitments?.length > 0 && (
          <CommitmentAvatarGroup
            commitments={commitments}
            purpose={variant}
            size="lg"
            tooltipMessage={t(
              `my:makeAPayment.alerts.${translationKey}.tooltip`,
              {
                count: commitments.length,
              },
            )}
          />
        )
      }
      variant={variant}
      buttonAction={
        <button
          onClick={onButtonClick}
          aria-label={t(`my:makeAPayment.alerts.cta`)}
          type="button"
        >
          {t(`my:makeAPayment.alerts.cta`)}
        </button>
      }
    />
  );
};
